export const UPDATE_MY_PROFILE_EMAIL_PENDING = 'UPDATE_MY_PROFILE_EMAIL_PENDING';
export const UPDATE_MY_PROFILE_EMAIL_FULFILLED = 'UPDATE_MY_PROFILE_EMAIL_FULFILLED';
export const UPDATE_MY_PROFILE_EMAIL_REJECTED = 'UPDATE_MY_PROFILE_EMAIL_REJECTED';

export default function reducer(state = {
  user: {},
  profile: {
    attributes: []
  },
  fetching: false,
  fetched: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'GET_CURRENT_USER_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_CURRENT_USER_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        user: action.payLoad.data,
      };
    }
    case 'GET_CURRENT_USER_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    case 'SET_CURRENT_USER': {
      return {
        ...state,
        user: action.payLoad,
      };
    }
    case UPDATE_MY_PROFILE_EMAIL_PENDING:
    case 'GET_PROFILE_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case UPDATE_MY_PROFILE_EMAIL_FULFILLED:
    case 'GET_PROFILE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        profile: action.payLoad.data,
      };
    }
    case UPDATE_MY_PROFILE_EMAIL_REJECTED:
    case 'GET_PROFILE_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    case 'DELETE_ACCOUNT_SUCCESS': {
      return {
        ...state,
        redirectAfterDelete: true
      };
    }
    default:
  }

  return {...state};
}
